module.exports = __webpack_public_path__ + "static/media/spinner.7ebd97e3.svg";